module.exports = __webpack_public_path__ + "media/customizations/trinityfalls/logo-new-81f427deefc8842a7e5b9f06d6837161.png";